var _a;
function cov_13y298zkc4() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/i18n.ts";
    var hash = "b8983360733de3a49f1b1a77a53efb742770115b";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/i18n.ts",
        statementMap: {
            "0": {
                start: {
                    line: 6,
                    column: 25
                },
                end: {
                    line: 6,
                    column: 63
                }
            },
            "1": {
                start: {
                    line: 16,
                    column: 34
                },
                end: {
                    line: 16,
                    column: 40
                }
            },
            "2": {
                start: {
                    line: 17,
                    column: 20
                },
                end: {
                    line: 17,
                    column: 33
                }
            },
            "3": {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 19,
                    column: 45
                }
            },
            "4": {
                start: {
                    line: 21,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 1
                }
            },
            "5": {
                start: {
                    line: 22,
                    column: 1
                },
                end: {
                    line: 22,
                    column: 58
                }
            },
            "6": {
                start: {
                    line: 29,
                    column: 0
                },
                end: {
                    line: 59,
                    column: 4
                }
            },
            "7": {
                start: {
                    line: 38,
                    column: 4
                },
                end: {
                    line: 38,
                    column: 59
                }
            },
            "8": {
                start: {
                    line: 58,
                    column: 2
                },
                end: {
                    line: 58,
                    column: 48
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 36,
                        column: 17
                    },
                    end: {
                        line: 36,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 36,
                        column: 37
                    },
                    end: {
                        line: 39,
                        column: 4
                    }
                },
                line: 36
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 57,
                        column: 8
                    },
                    end: {
                        line: 57,
                        column: 9
                    }
                },
                loc: {
                    start: {
                        line: 57,
                        column: 15
                    },
                    end: {
                        line: 59,
                        column: 2
                    }
                },
                line: 57
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 21,
                        column: 0
                    },
                    end: {
                        line: 23,
                        column: 1
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 21,
                            column: 0
                        },
                        end: {
                            line: 23,
                            column: 1
                        }
                    }, {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }],
                line: 21
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0
        },
        f: {
            "0": 0,
            "1": 0
        },
        b: {
            "0": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "b8983360733de3a49f1b1a77a53efb742770115b"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_13y298zkc4 = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_13y298zkc4();
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
const isDevelopmentEnv = (cov_13y298zkc4().s[0]++, process.env.NODE_ENV === 'development');
const initialSupportedLanguages = (cov_13y298zkc4().s[1]++, ['en']);
const vaporWindow = (cov_13y298zkc4().s[2]++, window);
let supportedLngs = (cov_13y298zkc4().s[3]++, initialSupportedLanguages);
cov_13y298zkc4().s[4]++;
if ((_a = vaporWindow === null || vaporWindow === void 0 ? void 0 : vaporWindow.vaporio) === null || _a === void 0 ? void 0 : _a.i18n) {
    cov_13y298zkc4().b[0][0]++;
    cov_13y298zkc4().s[5]++;
    supportedLngs = initialSupportedLanguages.concat(['es']);
}
else {
    cov_13y298zkc4().b[0][1]++;
}
cov_13y298zkc4().s[6]++;
i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    backend: {
        addPath: '/translations/add/{{lng}}/{{ns}}',
        loadPath: '/translations/{{lng}}/{{ns}}.json',
        parsePayload: (namespace, key) => {
            cov_13y298zkc4().f[0]++;
            cov_13y298zkc4().s[7]++;
            return {
                [key.toUpperCase().replace(/ /g, '_')]: key
            };
        }
    },
    contextSeparator: '__',
    debug: isDevelopmentEnv,
    defaultNS: 'Common',
    fallbackLng: 'en',
    fallbackNS: 'Common',
    initImmediate: false,
    interpolation: {
        escapeValue: false
    },
    load: 'languageOnly',
    lowerCaseLng: true,
    ns: ['ActivityLogs', 'Components', 'Login', 'Common'],
    partialBundledLanguages: true,
    pluralSeparator: '__',
    saveMissing: isDevelopmentEnv,
    saveMissingTo: 'all',
    supportedLngs
}).catch(e => {
    cov_13y298zkc4().f[1]++;
    cov_13y298zkc4().s[8]++;
    throw new Error(`error loading i18next ${e}`);
});
export default i18n;
